import React, { Component } from 'react'
import { Main, Full } from '../components/Content'

class FourOFour extends Component {
    render() {
        return (
            <Main>
                <Full>
                    <h1>404</h1>
                    <p>404 - Oeps, deze pagina bestaat niet</p>
                </Full>
            </Main>
		)
    }
}

export default FourOFour


// WEBPACK FOOTER //
// ./src/pages/404.js